import { AlertCard } from "~/components/ui/card/AlertCard";

import styles from "./BlockedAccessNotice.module.scss";

/**
 * What a member without billing access sees while the team's subscription
 * can't be used (the app sends everyone to billing): only the admin can fix
 * it.
 */
const PausedAccessNotice = () => (
  <AlertCard
    type="warning"
    title="Access is paused"
    content={
      <p className={styles.text}>
        Ask your team admin to update the payment details.
      </p>
    }
    className={styles.notice}
  />
);

export default PausedAccessNotice;
